package dk.smark.demo.map

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun OsmMap(
    controller: MapController,
    modifier: Modifier,
    onEvent: (MapEvent) -> Unit,
) {
    OsmMapShared(controller = controller, modifier = modifier, onEvent = onEvent)
}
